import React, { useEffect, useState, useContext } from "react";
import ApiService from "../../api/ApiService";
import AppContext from "../../context/AppContext";
import Tooltip from '@mui/material/Tooltip';
import notification from "../../helpers/notification";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Modal } from 'react-bootstrap';

const DownloadTenbe = () => {

    const { handleSubmit } = useForm();
    const navigate = useNavigate();
    const { donor } = useContext(AppContext);

    const [btnshow, setButtonshow] = useState(false);
    const [status, setStatus] = useState(false);
    const [pan, setPan] = useState([]);
    const [years, setYears] = useState([]);
    const [selectedPan, setSelectedPan] = useState("");

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isDialogOpenPan, setIsDialogOpenPan] = useState(false);
    const [isDownloadDialogOpen, setIsDownloadDialogOpen] = useState(false);

    // separate loaders
    const [loaderMainBtn, setLoaderMainBtn] = useState(false);
    const [loaderFy25, setLoaderFy25] = useState(false);
    const [loaderFy26, setLoaderFy26] = useState(false);
    const [loaderPan, setLoaderPan] = useState(false);

    const handleDownloadModal = () => setIsDownloadDialogOpen(true);

    const closeDialogView = () => setIsDialogOpen(false);
    const closeDialogViewPan = () => setIsDialogOpenPan(false);
    const closeDownloadDialogView = () => setIsDownloadDialogOpen(false);

    const fetchTenbedonorList = async (id = null) => {
        try {

            const res = await ApiService.fetchTenbedonorList(id);

            setButtonshow(res?.btnshow ?? false);
            setStatus(res?.status ?? false);

            const uniquePan = Array.isArray(res?.pan)
                ? [...new Set(res.pan)]
                : [];
            const years = Array.isArray(res?.years)
                ? [...new Set(res.years)]
                : [];

            setPan(uniquePan);
            setYears(years);

        } catch (error) {
            console.error(error);
        }
    };

    const downloadFile = (blob, fileName) => {

        const fileType = blob.type.split("/")[1];

        const link = document.createElement("a");

        link.href = URL.createObjectURL(blob);

        link.download = `${fileName}.${fileType}`;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    const handleDownloadBe = async (panList) => {

        if (!Array.isArray(panList) || !panList.length) {

            notification("error", "No PAN");

            return;
        }

        if (panList.length > 1) {

            setIsDialogOpenPan(true);

            return;
        }

        try {

            setLoaderFy25(true);

            const blob = await ApiService.downloadRecieptBe(panList[0]);

            downloadFile(blob, `${panList[0]}_FY25`);

            notification("success", "Downloaded");

            navigate("/download-success/", {

                state: {
                    phone: donor?.phone,
                    pan: panList[0]
                }

            });

        }

        catch (e) {

            setIsDialogOpen(true);

        }

        finally {

            setLoaderFy25(false);

        }
    };

    const handleDownloadBeFy26 = async (panList) => {

        if (!Array.isArray(panList) || !panList.length) {

            notification("error", "No PAN");

            return;
        }

        if (panList.length > 1) {

            setIsDialogOpenPan(true);

            return;
        }

        try {

            setLoaderFy26(true);

            const blob = await ApiService.downloadRecieptBeFy26(panList[0]);

            downloadFile(blob, `${panList[0]}_FY26`);

            notification("success", "Downloaded");

            navigate("/download-success/", {

                state: {
                    phone: donor?.phone,
                    pan: panList[0]
                }

            });

        }

        catch (e) {

            setIsDialogOpen(true);

        }

        finally {

            setLoaderFy26(false);

        }
    };

    const handleMultiplePan = async () => {

        if (!selectedPan) {

            notification("error", "Select PAN");

            return;
        }

        try {

            setLoaderPan(true);

            const blob = await ApiService.downloadRecieptBe(selectedPan);

            downloadFile(blob, `${selectedPan}_multiple`);

            notification("success", "Downloaded");

            navigate("/download-success/", {

                state: {
                    phone: donor?.phone,
                    pan: selectedPan
                }

            });

        }

        catch (e) {

            notification("error", "contact Support");

        }

        finally {

            setLoaderPan(false);

        }
    };

    useEffect(() => {

        if (donor?.phone) {

            fetchTenbedonorList(donor.phone);

        }

    }, [donor]);

    if (!btnshow || !status) return null;

    return (

        <>

            <Tooltip title="Download">

                <button

                    className="custom-btn-cls box-hover text-uppercase d-flex align-items-center justify-content-center"

                    onClick={!loaderMainBtn ? handleDownloadModal : null}

                    disabled={loaderMainBtn}

                >

                    Download 10BE

                    {loaderMainBtn &&

                        <div className="spinner-border text-light ms-2" />

                    }

                </button>

            </Tooltip>

            <Modal centered show={isDialogOpen} onHide={closeDialogView}>
                <div className="modal-wrap text-center p-4" style={{ maxWidth: "450px", margin: "0 auto" }}>
                    <button className="btn-close position-absolute" style={{ right: "10px", top: "10px" }} onClick={closeDialogView}></button>
                    <h2>Contact Support!</h2>
                    <p className="mt-2">
                        Kindly send your queries to
                        <a href="mailto:support@iskconattapur.com" className="fw-bold text-decoration-none"> support@iskconattapur.com</a>
                    </p>
                    <p className="mt-2">Hare Krishna.</p>
                </div>
            </Modal>

            <Modal centered show={isDownloadDialogOpen} onHide={closeDownloadDialogView}>

                <div className="modal-wrap text-center p-4">

                    <button
                        className="btn-close position-absolute"
                        style={{ right: "10px", top: "10px" }}
                        onClick={closeDownloadDialogView}
                    ></button>


                    <h5>

                        Download Form

                    </h5>

                    <div className="row g-3">
                        <div className="col-md-12 text-center">
                            <button
                                className="custom-btn-cls px-4"
                                onClick={!loaderFy26 ? () => handleDownloadBeFy26(pan) : null}
                                disabled={loaderFy26}
                            >
                                Download FY {years[0]}

                                {loaderFy26 && (
                                    <div className="spinner-border text-light ms-2"></div>
                                )}
                            </button>
                        </div>
                    </div>

                </div>

            </Modal>

            <Modal centered show={isDialogOpenPan} onHide={closeDialogViewPan}>

                <form

                    onSubmit={handleSubmit(handleMultiplePan)}

                    className="p-4"

                >

                    <select

                        className="form-select"

                        value={selectedPan}

                        onChange={(e) => setSelectedPan(e.target.value)}

                    >

                        <option value="">

                            select PAN

                        </option>

                        {pan.map((p, i) => (

                            <option key={i} value={p}>

                                {p}

                            </option>

                        ))}

                    </select>

                    <button

                        type="submit"

                        className="custom-btn-cls mt-3"

                        disabled={loaderPan}

                    >

                        Download

                        {loaderPan &&

                            <div className="spinner-border text-light ms-2" />

                        }

                    </button>

                </form>

            </Modal>

        </>

    );

};

export default DownloadTenbe;
